import { useParams } from 'react-router-dom';
import { AlbumsList } from '@/features/albums/AlbumsList';
import { AlbumView } from '@/features/albums/AlbumView';
import { Showcase } from '@/features/albums/Showcase';
import { BackHeader } from '@/components/BackHeader';
import { useAlbums } from '@/features/albums/useAlbums';

export function AlbumPage() {
  const { id } = useParams();
  if (id) return <AlbumView />;
  return <AlbumIndex />;
}

function AlbumIndex() {
  const { data } = useAlbums();
  const hasAlbums = !!data && data.length > 0;
  return (
    <div className="flex flex-col">
      <BackHeader title="Фотоальбомы и моменты" />
      <Showcase />
      {hasAlbums ? (
        <div className="mt-6">
          <h2 className="text-lg font-semibold mb-3">Альбомы</h2>
          <AlbumsList />
        </div>
      ) : null}
    </div>
  );
}
